import axios from 'axios';

export default {
  // eslint-disable-next-line no-unused-vars
  async LOAD_processFile({ commit }, doc) {
    const result = await axios.get(`/files/process/${doc.documentType}/${doc.id}`);
    commit('SET_file', result.data);
    return JSON.parse(result.data);
  },
};
